<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AreaService }  from '@/services/area.service'; 

export default {
    props: {
        google: {
            type: Object,
            required: true,
        },
        map: {
            type: Object,
            required: true,
        },
        layerData: {
            type: Object,
            required: true,
        },
        layerID: {
            type: Number,
            required: true,
        },
        maxOpacity: {
            type: Number,
            required: false,
        },
        bbox: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            layer: null,
        };
    },
    methods: {
        removeOverlay() {
            if (this.layer) {
                this.layer.setMap(null);
            }
        },
        getMap() {
            return this.map;
        },
    },
    watch: {
        layerData: {
            immediate: true,
            handler(data) {
                const { GroundOverlay } = this.google.maps;

                this.removeOverlay();

                if (!data || !data.mapThumbnailURL) {
                    return;
                }
 
                const imageBounds = {
                    north: this.bbox.NE[1],
                    south: this.bbox.SW[1],
                    east: this.bbox.NE[0],
                    west: this.bbox.SW[0]
                }

                // create an image and set src to thumbnail url
                // this adds image to local cache
              //  let img = new Image();
              //  img.src = data.mapThumbnailURL
                let counter = 0;
                let self = this;
                function loadImage() {
                    counter++;
                    if(counter > 2){
                        console.info('tried 3 times to load, now ending')
                        self.$emit('map-url-loaded');
                        return;
                    }
                    let img = new Image();
                    img.src = data.mapThumbnailURL;

                    img.addEventListener('load', function(){
                        self.layer.url = data.mapThumbnailURL
                        self.layer.setMap(self.map)

                        self.$emit('map-url-loaded');
                       
                    })
                    img.addEventListener('error', function(){
                        console.debug('image load error, trying again')
                        loadImage();
                    })  
                }

                loadImage();
              
                this.$emit('loading-map-url')

                this.layer = new GroundOverlay(
                    null,
                    imageBounds,
                    {clickable:false}
                )
                this.layer.setMap(this.map)
               
            },
        },
        opacity: {
            immediate: true,
            handler(opacity) {
                if(this.layer){
                    this.layer.setOpacity(opacity);
                }
            },
        },
        displayLayer: {
            immediate: true,
            handler(displayLayer) {
                if (displayLayer) {
                    if (isNaN(this.maxOpacity)) {
                        this.layerData.opacity = 1;
                    } else {
                        this.layerData.opacity = this.maxOpacity;
                    }
                } else {
                    this.layerData.opacity = 0;
                }
            },
        },
        maxOpacity: {
            immediate: true,
            handler(maxOpacity) {
                if (!isNaN(maxOpacity) && this.layerData.displayLayer) {
                    this.layerData.opacity = maxOpacity;
                }
            },
        },
    },
    mounted() {
        this.clearAreasSubscription = AreaService.clearAreas$.subscribe(function() {
            this.removeOverlay();
            this.$emit("tiles-loading", false);
        }.bind(this));
    },
    beforeDestroy() {
        this.clearAreasSubscription.unsubscribe();
    },
    computed: {
        opacity() {
            return this.layerData.opacity;
        },
        displayLayer() {
            return this.layerData.displayLayer;
        },
    },
    destroyed() {
        this.removeOverlay();
    },
    render(h) {
        return h("", "");
    },
};
</script>
